"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderResultItems = void 0;
var NearbyResultItemComponent_1 = require("@/pages/detail/components/NearbyResultItemComponent");
var React = require("react");
var NearbyCallSaga_1 = require("../sagas/NearbyCallSaga");
exports.renderResultItems = function (props) {
    var renderResultItem = function (it, i) {
        return (React.createElement(NearbyResultItemComponent_1.NearbyResultItemComponent, { key: i, i: i, item: it, t: props.t, backgroundColor: NearbyCallSaga_1.getIconBackgroundColor(props.popNearbyTab), iconClass: NearbyCallSaga_1.getIconClass(props.popNearbyTab), onResultItemClick: props.onResultItemClick, from: props.property.lat ? { lat: props.property.lat, lng: props.property.lng } : null }));
    };
    return (React.createElement("div", { className: "c-distance-card c-distance-card--active c-distance-card--sm" },
        React.createElement("div", { className: "c-distance-card__items" }, props.nearbyMap.big.results.map(renderResultItem))));
};
